import ImageIcon from '@mui/icons-material/Image';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import { Container } from './styles';

import { DropContainerComponent } from '../../../components/basics/DropContainerComponent';
import { DropzoneComponent, FileProps } from '../../../components/basics/DropzoneComponent';
import { PreviewComponent } from '../ImagePreviewComponent/ImagePreviewComponent';

interface Props {
  uploadedFiles: FileProps[];
  setUploadedFiles: (uploadedFiles: FileProps[]) => void;
  onClearFiles: () => void;
}

export const PostModalAttachments = ({ uploadedFiles, setUploadedFiles, onClearFiles }: Props) => {
  const [showDropzoneMedia, setShowDropzoneMedia] = useState(false);

  const handleUploadMedia = (files: FileProps[]) => {
    setShowDropzoneMedia(false);

    //remover caracteres especiais do nome do arquivo
    let filesArray = files.map((file) => {
      let newName = file.name.replace(/[^a-zA-Z0-9.]/g, '');
      let newFile = new File([file], newName, { type: file.type });
      newFile.preview = file.preview;
      return newFile;
    });

    setUploadedFiles([...uploadedFiles, ...filesArray]);
  };

  return (
    <>
      {
        <>
          {uploadedFiles?.length > 0 ? (
            <PreviewComponent uploadedFiles={uploadedFiles} handleClearFiles={onClearFiles} />
          ) : (
            <>
              {showDropzoneMedia ? (
                <DropzoneComponent selectedFiles={handleUploadMedia}>
                  <DropContainerComponent title="Adicione fotos/videos ou arquivos" />
                </DropzoneComponent>
              ) : (
                <Container>
                  <Box>
                    <Typography variant="body1" color="text.primary" align="left">
                      Adicionar à sua publicação
                    </Typography>
                  </Box>
                  <Box>
                    <Tooltip title="Adicionar Mídias" placement="top">
                      <IconButton onClick={() => setShowDropzoneMedia(true)}>
                        <ImageIcon color="primary" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Container>
              )}
            </>
          )}
        </>
      }
    </>
  );
};
